import jwtDecode from 'jwt-decode';
import * as auth from '../actions/authActions';

const initialState = {
  access: undefined,
  refresh: undefined,
  errors: {}
};

export default (state = initialState, action) => {
  switch (action.type) {
    case auth.LOGIN_SUCCESS:
    case auth.TOKEN_RECEIVED:
      return {
        access: {
          token: action.payload.access,
          ...jwtDecode(action.payload.access)
        },
        refresh: {
          token: action.payload.refresh,
          ...jwtDecode(action.payload.refresh)
        },
        errors: {}
      };
    case auth.LOGIN_FAILURE:
    case auth.TOKEN_FAILURE:
      return {
        access: undefined,
        refresh: undefined,
        errors: action.payload.data || {
          non_field_errors: action.payload.statusText
        }
      };

    case auth.LOGOUT:
      return initialState;

    default:
      return state;
  }
};

export function getAccessToken(state) {
  if (state.access) {
    return state.access.token;
  }
  return null;
}

export function getRefreshToken(state) {
  if (state.refresh) {
    return state.refresh.token;
  }
  return null;
}

export function isAccessTokenExpired(state) {
  if (state.access && state.access.exp) {
    return 1000 * state.access.exp - new Date().getTime() < 60000;
  }
  return true;
}

export function isRefreshTokenExpired(state) {
  if (state.refresh && state.refresh.exp) {
    return 1000 * state.refresh.exp - new Date().getTime() < 60000;
  }
  return true;
}

export function isAuthenticated(state) {
  return !isRefreshTokenExpired(state);
}

export function errors(state) {
  return state.errors;
}
